import GenericRequest, { METHOD_POST } from '../../webservices/GenericRequest';
import { ApiEndpoints } from '../../webservices/endpoint';

export class WorkChecksTask extends GenericRequest {

    _request;

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MONTLY_WORK_CHECKS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/work-checks/work-checks-list/WorkChecksTask.js